import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { getModuleDetail } from '../../../Redux/action/Admin/RolePermissionAction';
import Beatloader from '../../../Common/Loaders/Beatloader';

const ViewRoles = ({ roleID, handleCloseView }) => {


    const navigate = useNavigate();
    const dispatch = useDispatch();

    let [showLoader, setShowLoader] = useState(false);
    let [detail, setDetail] = useState([]);
    let [permissionList, setPermissionList] = useState([]);


    useEffect(() => {
        if (roleID) {
            setShowLoader(true);
            dispatch(getModuleDetail(roleID));
        } else {
            handleCloseView();
        }

    }, [roleID]);

    let { loadingModuleDetail, moduleDetailDataError, moduleDetailData, moduleDetailPermissionData } = useSelector(state => state?.RolePermissionReducer);

    useEffect(() => {
        if (loadingModuleDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        };

        if (moduleDetailData) {
            setDetail(moduleDetailData);
        }

        if (moduleDetailPermissionData) {
            setPermissionList(moduleDetailPermissionData);
        }

    }, [loadingModuleDetail, moduleDetailDataError, moduleDetailData, moduleDetailPermissionData]);

    return (
        <>
            {showLoader ?
                <Beatloader /> :
                <div className="container">
                    <div className="col-md-12">
                        <div className="main_section_detail">
                            {/* <h2><Link className="query_info" to={-1}><img src="/img/re_darect.png" alt="Query" /></Link>Role & Permissions Information</h2> */}
                            <div className="new_infometion_table p-3">
                                <div className="main_detail_form">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <h4>
                                                    Role Name
                                                </h4>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control"
                                                    placeholder="Enter Role here"
                                                    disabled={true}
                                                    value={detail?.name}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="main-nav-det mt-2">
                                        <h4>Assigned Permissions</h4>
                                    </div>
                                    <div className="row">
                                        {permissionList.length > 0 ? (
                                            permissionList.map((module, index) => {
                                                return (module.permission.filter(permission => permission?.assign_permission).length > 0) && <div key={index} className="col-md-4 mb-3">
                                                    <div
                                                        className="table-responsive role_css acl-role"
                                                        style={{ height: '200px', overflowY: 'scroll', margin: '10px 0px' }}
                                                    >
                                                        <table className="table table-striped permission_table">
                                                            <tbody>
                                                                <tr>
                                                                    <th className='color-black'>{module.name}</th>
                                                                </tr>
                                                                {module.permission.filter(permission => permission?.assign_permission).length > 0 ? (
                                                                    module.permission.map((permission, i) => (
                                                                        permission?.assign_permission && (
                                                                            <tr key={i}>
                                                                                <td>{permission.name}</td>
                                                                            </tr>
                                                                        )
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td><i>No permissions assigned</i></td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            })
                                        ) : (
                                            <div className="text-center">
                                                <i>No permission assigned for this role.</i>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                }
        </>
    )
}

export default ViewRoles